import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import SubProductFinanceAssetService from "services/Setup/Organization/SubProductFinanceAssetService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  SubProductFinanceAssetList: {},
  refreshList: false,
  SubProductFinanceAssetApprovalList: {},
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
};

export const postSubProductFinanceAsset = createAsyncThunk(
  "SubProductFinanceAsset/postSubProductFinanceAsset",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await SubProductFinanceAssetService.postSubProductFinanceAsset(data);
      // console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getSubProductFinanceAssetList = createAsyncThunk(
  "SubProductFinanceAsset/getSubProductFinanceAssetList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await SubProductFinanceAssetService.getSubProductFinanceAssetList(
          userInput
        );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getSubProductFinanceAssetApprovalList = createAsyncThunk(
  "SubProductFinanceAsset/getSubProductFinanceAssetApprovalList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await SubProductFinanceAssetService.getSubProductFinanceAssetApprovalList(
          userInput
        );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putSubProductFinanceAssetApproval = createAsyncThunk(
  "SubProductFinanceAsset/putSubProductFinanceAssetApproval",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await SubProductFinanceAssetService.putSubProductFinanceAssetApproval(
          data
        );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putSubProductFinanceAssetRequest = createAsyncThunk(
  "SubProductFinanceAsset/putSubProductFinanceAssetRequest",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await SubProductFinanceAssetService.putSubProductFinanceAssetRequest(
          data
        );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          // message: "Error",
          // description: "Unexpected response!",
          message: response.status,
          description: response.statusText,
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getSubProductFinanceAssetDetail = createAsyncThunk(
  "SubProductFinanceAsset/getSubProductFinanceAssetDetail",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await SubProductFinanceAssetService.getSubProductFinanceAssetDetail(
          data
        );
      if (response.status === 200) {
        if (response && response.data) {
          return response;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updateSubProductFinanceAsset = createAsyncThunk(
  "SubProductFinanceAsset/updateSubProductFinanceAsset",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await SubProductFinanceAssetService.updateSubProductFinanceAsset(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteSubProductFinanceAsset = createAsyncThunk(
  "SubProductFinanceAsset/deleteSubProductFinanceAsset",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await SubProductFinanceAssetService.deleteSubProductFinanceAsset(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const SubProductFinanceAssetSlice = createSlice({
  name: "SubProductFinanceAsset",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder

      //post
      .addCase(postSubProductFinanceAsset.pending, (state) => {
        state.loading = true;
      })
      .addCase(postSubProductFinanceAsset.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
      })
      .addCase(postSubProductFinanceAsset.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list
      .addCase(getSubProductFinanceAssetList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getSubProductFinanceAssetList.fulfilled, (state, action) => {
        state.loading = false;
        state.SubProductFinanceAssetList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getSubProductFinanceAssetList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //SubProductFinanceAsset approval list
      .addCase(getSubProductFinanceAssetApprovalList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(
        getSubProductFinanceAssetApprovalList.fulfilled,
        (state, action) => {
          state.loading = false;
          state.SubProductFinanceAssetApprovalList = action.payload;
          state.getCount = action.payload.count;
        }
      )
      .addCase(
        getSubProductFinanceAssetApprovalList.rejected,
        (state, action) => {
          state.loading = false;
          state.SubProductFinanceAssetApprovalList = action.payload;
        }
      )

      //SubProductFinanceAsset approval approve
      .addCase(putSubProductFinanceAssetApproval.pending, (state) => {
        state.loading = true;
        // state.redirect = "";
      })
      .addCase(putSubProductFinanceAssetApproval.fulfilled, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(putSubProductFinanceAssetApproval.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //SubProductFinanceAsset approval request
      .addCase(putSubProductFinanceAssetRequest.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(putSubProductFinanceAssetRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(putSubProductFinanceAssetRequest.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //detail
      .addCase(getSubProductFinanceAssetDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSubProductFinanceAssetDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(getSubProductFinanceAssetDetail.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //update
      .addCase(updateSubProductFinanceAsset.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateSubProductFinanceAsset.fulfilled, (state, action) => {
        state.loading = false;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updateSubProductFinanceAsset.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //delete
      .addCase(deleteSubProductFinanceAsset.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSubProductFinanceAsset.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deleteSubProductFinanceAsset.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  //    update,
  showNotification,
  hideNotification,
  showLoading,
} = SubProductFinanceAssetSlice.actions;

export default SubProductFinanceAssetSlice.reducer;
